module.exports = __webpack_public_path__ + "img/water_des_2.4abf224a.jpg";